import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RequestServiceService } from '../../core/services/request-service/request-service.service';
import { MessagesService } from '../../core/services/messages/messages.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  otp_val: any;
  incorrect: boolean = false;
  public timeLeft: string = '00:00';
  email: any;
  timeStatus: boolean = false;
  opt_sent: Boolean = false;
  sendAgain: Boolean = false;
  mobile: any;
  interval: any;
  @ViewChild('myModal')
  myModal!: ElementRef;
  messaage: any;
  constructor(
    private requestApiService: RequestServiceService, private modalService: NgbModal,
    private router: Router,
    public messageservices: MessagesService, 
  ) { }
  private timerSubscription: Subscription | undefined;
  // otp_Sent:any;
  ngOnInit(): void {

    if (history.state.data !== undefined || history.state.mob !== undefined) {
      this.email = history.state.data;
      this.mobile = history.state.mob;
    }
    else {
      this.router.navigate(['/login']);
    }
    this.updateTime();
    // Set up a timer that updates every second
    this.timerSubscription = timer(1000, 1000).subscribe(() => {
      this.updateTime();
    });
  }
  private expirationTime: number = new Date().getTime() + 60 * 1000; // S
  updateTime() {
    const currentTime = new Date().getTime();
    const remainingTime = Math.max(0, this.expirationTime - currentTime);
    this.timeLeft = this.formatTime(remainingTime / 1000);

    if (remainingTime === 0) {
      this.timerSubscription?.unsubscribe(); // Stop the timer when it reaches 0
      // Do something when the time is up
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
  }

  

  pad(value: number): string {
    // Helper function to pad single-digit numbers with a leading zero
    return value < 10 ? `0${value}` : `${value}`;
  }

  isTimerExpired(): boolean {
    // Check if the timer has reached 0
    return this.getSecondsLeft() === 0;
  }
  
  getSecondsLeft(): number {
    const currentTime = new Date().getTime();
   
    return Math.max(0, this.expirationTime - currentTime);
  }

  onOtpChange(otp: any) {
  
    this.otp_val = otp;

    if (this.otp_val.length == 4) {
      this.otpVerify(this.otp_val, this.email);
    }
  }
  openModal(text: any) {
    this.messaage = text
    this.modalService.open(this.myModal, { backdrop: 'static', keyboard: false ,centered: true});
    this.router.navigate(['/dashboard']);

  }
  close() {
    this.modalService.dismissAll()
  }
  otpVerify(otp: any, email: any) {
    this.incorrect = false;
    const loginParam = {
      email: email,
      otp: otp,
      otp_type: "verify_email",
      "otp_entity": "merchant"
    };

    this.requestApiService.otp_Verify(loginParam).then(response => {
     
      if (response.success) {

        // localStorage.setItem("res_uid",response.data.res_id)
        this.openModal(response.msg)
        this.expirationTime = new Date().getTime() + 60 * 1000;
      
        this.messageservices.showNotification('OTP Verified, Please wait till Admin verifies your account..', 'success', 'success');
      } else {
        this.incorrect = true;
        this.messageservices.showNotification('OTP not verified. Please try again.', 'error', 'error');
      }
    });
  }

  // startTimer() {
  //   this.interval = setInterval(() => {
  //     if (this.timeLeft > 0) {
  //       this.sendAgain = false;
  //       this.timeLeft--;
  //     } else {
  //       this.sendAgain = true;
  //     }
  //   }, 1000)
  // }

  // pauseTimer() {
  //   clearInterval(this.interval);
  // }
  sendOtp() {
   
   
      let data = {
        "email":this.email,
        "otp_type": "verify_email",
        "otp_entity": "merchant"
      }
      localStorage.clear()
      this.requestApiService.verifyEmail(data).then(response => {
        if (response.success) {
        
          this.expirationTime = new Date().getTime() + 60 * 1000;
          this.updateTime();
      // Set up a timer that updates every second
      this.timerSubscription = timer(1000, 1000).subscribe(() => {
        this.updateTime();
      });
          this.messageservices.showNotification(response.msg, 'success', 'success');
        } else {
          this.messageservices.showNotification(response.msg, 'error', 'error');
        }
      });
    
  }

  otpSendAgain() {
   // this.timeLeft = 90;

    const param = {
      email: this.email,
      "otp_type": "verify_email",
      "otp_entity": "merchant"
    }

    this.requestApiService.otpResend(param).then(response => {
      if (response.success) {
       // this.startTimer();
        this.messageservices.showNotification('OTP Sent Successfully', 'success', 'success');
      } else {
        this.messageservices.showNotification(response.message, 'danger', 'error');
      }
    });
  }
}
